"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemperatureUnit = void 0;
var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit[TemperatureUnit["kelvin"] = 0] = "kelvin";
    TemperatureUnit[TemperatureUnit["Celsius"] = 1] = "Celsius";
    TemperatureUnit[TemperatureUnit["Fahrenheit"] = 2] = "Fahrenheit";
})(TemperatureUnit = exports.TemperatureUnit || (exports.TemperatureUnit = {}));
//# sourceMappingURL=TemperatureUnit.js.map